import { IForm } from '@/components/types'
import { useSearchDateShortcut, useSearchDuration, useSearchVideoTitle } from "@/hooks/useSearch";
const shortcuts = useSearchDateShortcut()

const [fetchSuggestions] = useSearchVideoTitle()
const durationOptions = useSearchDuration()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'autocomplete',
      label: '视频标题',
      placeholder: '请输入视频标题',
      otherOptions: {
        clearable: true,
        'fetch-suggestions': fetchSuggestions
      }
    },
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      clearable: true,
      placeholder: '请选择部门'
    },
    {
      field: 'accessTime',
      type: 'datepicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      field: 'duration',
      type: 'select',
      label: '访问时长',
      placeholder: '请选择访问时长',
      clearable: true,
      options: durationOptions
    }
  ]
}
